import { StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

import { storeCreator } from '@/utils/store/store.utils';

export const RESEND_CODE_TIMER_LOCAL_STORAGE_KEY = 'resend-code-timer-store';

interface Timer {
  expiredIn: string;
}

interface State {
  timer?: Timer;
  setTimer: (timer: Timer) => void;
  clearTimer: () => void;
}

export const useResendCodeTimerStore = storeCreator<State>(
  persist(
    (set) => ({
      timer: undefined,
      setTimer: (timer: Timer) => set(() => ({ timer })),
      clearTimer: () => set(() => ({ timer: undefined }))}),
    {
      name: RESEND_CODE_TIMER_LOCAL_STORAGE_KEY,
      partialize: (state) => ({ timer: state.timer }),
    }
  ) as StateCreator<State>
);
